/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_MicrosoftInputs */

const en_invite_x15_microsoft = /** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Microsoft`)
};

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const ar_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const he_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const ur_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const es_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const fr_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const de_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const pt_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const hi_invite_x15_microsoft = en_invite_x15_microsoft;

/** @type {(inputs: Invite_X15_MicrosoftInputs) => LocalizedString} */
const bn_invite_x15_microsoft = en_invite_x15_microsoft;

/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Invite_X15_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_microsoft = /** @type {((inputs?: Invite_X15_MicrosoftInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_MicrosoftInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_microsoft(inputs)
	if (locale === "he") return he_invite_x15_microsoft(inputs)
	if (locale === "ur") return ur_invite_x15_microsoft(inputs)
	if (locale === "es") return es_invite_x15_microsoft(inputs)
	if (locale === "fr") return fr_invite_x15_microsoft(inputs)
	if (locale === "de") return de_invite_x15_microsoft(inputs)
	if (locale === "pt") return pt_invite_x15_microsoft(inputs)
	if (locale === "hi") return hi_invite_x15_microsoft(inputs)
	if (locale === "bn") return bn_invite_x15_microsoft(inputs)
	return /** @type {LocalizedString} */ ("Continue with Microsoft")
});